<template>
  <section class="detail pt-50 pb-20">
    <div class="container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-xl-12">
            <div class="detail__title">
              <h2>{{ auctionDetail.TenKeHoach }}</h2>
            </div>
          </div>
          <div class="col-lg-12 col-md-12">
            <div class="detail-tab">
              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    class="nav-item nav-link"
                    v-bind:class="{ 'active show': tab == 1 }"
                    id="nav-1-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="nav-1"
                    aria-selected="true"
                    v-on:click="tab = 1"
                  >
                    Thông tin phiên đấu giá
                  </a>
                  <a
                    class="nav-item nav-link"
                    v-bind:class="{ 'active show': tab == 2 }"
                    id="nav-2-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="nav-2"
                    aria-selected="false"
                    v-on:click="tab = 2"
                  >
                    Chi tiết tài sản
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="tab-content" id="nav-tabContent">
              <!-- card one -->
              <div
                v-if="tab == 1"
                class="tab-pane fade"
                v-bind:class="{ 'active show': tab == 1 }"
                id="nav-1"
                role="tabpanel"
                aria-labelledby="nav-1-tab"
              >
                <div class="row">
                  <!--Image Detail-->
                  <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                    <div class="detail__img">
                      <carousel
                        :paginationPosition="'bottom-overlay'"
                        :per-page="1"
                        :autoplay="true"
                        :loop="true"
                        :autoplayTimeout="3000"
                        v-if="auctionDetail.TaiSanDauGia && auctionDetail.TaiSanDauGia.length > 0"
                      >
                        <slide
                          data-index="0"
                          v-for="i in auctionDetail.TaiSanDauGia[0].DinhKem"
                          :key="i"
                          style="width: 100%; height: 350px;"
                        >
                          <img
                            alt=""
                            v-gallery:groupName
                            style="cursor: zoom-in;border-radius: 3px;object-fit: contain;width: 100%;min-height: 100%;"
                            :src="i.LinkDownload"
                          />
                        </slide>
                      </carousel>
                    </div>
                  </div>
                  <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
                    <div class="detail__info">
                      <span>{{ auctionDetail.MoTaTomTat }}</span>
                    </div>
                    <div class="detail__row" v-if="auctionDetail.DauGiaVien && auctionDetail.DauGiaVien.HoTen">
                      <span class="detail__label txt-main">Đấu giá viên:</span>
                      <span class="detail__value" style="text-decoration: underline;">
                        <a v-on:click="$modal.show('modal-auctioneer')">{{ auctionDetail.DauGiaVien.HoTen }}</a>
                      </span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Người có tài sản:</span>
                      <span class="detail__value">{{ auctionDetail.NguoiBanDauGia }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Ngày công bố:</span>
                      <span class="detail__value">{{
                        auctionDetail.NgayCongBo | formatDate(DateFormat['DD/MM/YYYY'])
                      }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Thời điểm bắt đầu phiên đấu giá:</span>
                      <span class="detail__value">{{ auctionDetail.BatDau | formatDate }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Thời điểm kết thúc phiên đấu giá:</span>
                      <span class="detail__value">{{ auctionDetail.ThoiGianXacNhanTrungGia | formatDate }}</span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Giá khởi điểm:</span>
                      <span class="detail__value"
                        >{{ auctionDetail.GiaKhoiDiem | formatPrice }} {{ auctionDetail.DonViTinh }}</span
                      >
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Bước giá:</span>
                      <span class="detail__value"
                        >{{ auctionDetail.BuocGia | formatPrice }} {{ auctionDetail.DonViTinh }}</span
                      >
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Chi phí tham gia đấu giá:</span>
                      <span class="detail__value">
                        {{ auctionDetail.PhiThamGiaDauGia | formatPrice }} {{ auctionDetail.DonViTinh }}
                      </span>
                    </div>
                    <div class="detail__row">
                      <span class="detail__label txt-main">Tiền đặt trước:</span>
                      <span class="detail__value">
                        {{ auctionDetail.SoTienDatCoc | formatPrice }} {{ auctionDetail.DonViTinh }}
                      </span>
                    </div>
                    <div>
                      <div class="detail__row">
                        <span class="detail__label txt-main primary-color">Mã khách hàng trúng đấu giá:</span>
                        <span class="detail__value">
                          {{ auctionDetail.MaNguoiTrungGia }}
                        </span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label txt-main primary-color">Giá trúng đấu giá:</span>
                        <span class="detail__value">
                          {{ auctionDetail.GiaTrungDauGia | formatPrice }} {{ auctionDetail.DonViTinh }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="tab == 2"
                class="tab-pane fade"
                v-bind:class="{ 'active show': tab == 2 }"
                id="nav-2"
                role="tabpanel"
                aria-labelledby="nav-2-tab"
              >
                <div class="row">
                  <!--Image Detail-->
                  <div class="col-xl-12">
                    <div class="detail__des" v-html="auctionDetail.TaiSanDauGia[0].MoTaChiTiet"></div>
                  </div>
                  <!--End Detail-->
                </div>
              </div>
              <!-- end card two -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

import Auction from '@/common/api/auction';
import mixin from '@/mixins/mixin';
import { DateFormat } from '@/constants';

export default {
  components: { Carousel, Slide },
  name: 'AuctionResultDetail',
  props: ['auctionId'],
  mixins: [mixin],
  data() {
    return {
      auctionDetail: {
        TenKeHoach: ''
      },
      isLoading: false,
      tab: 1,
      DateFormat
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.isLoading = true;
      Auction.getDetail(this.auctionId).then((res) => {
        this.auctionDetail = res.data.Data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/AuctionResult.vue